import React from "react";
import ReactDOM from "react-dom";
import classes from "./signin_info_modal.module.css";
import util from "../../../styles/utilities.module.css";

const SignInInfoModal = ({
  isOpen,
  continueHandler,
  cancelHandler = null,
  error = false
}) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={`${util.modalOverlay} ${classes["modal-overlay"]}`}>
      <div className={`${util.modalSurface} ${classes.modal}`}>
        <p className={classes.text}>
          {error
            ? "We're sorry! An unknown error was encountered. Please try again later."
            : `In order to export your work, we will need your permission to access your Google Drive. We will only be able to access files that we create. When asked, please select "Allow".`}
        </p>
        <div
          className={classes.confirmationBtnContainer}
          style={{
            justifyContent: cancelHandler ? "space-between" : "center"
          }}
        >
          {cancelHandler && (
            <button
              onClick={cancelHandler}
              type="button"
              className={`${util.btn} ${util['btn--ghost']}`}
            >
              Cancel
            </button>
          )}
          {!error && (
            <button
              onClick={continueHandler}
              type="button"
              className={util.btn}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SignInInfoModal;
